'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isInProductionMode = isInProductionMode;
exports.isPdf = isPdf;
/**
 * Returns true, if the current application is in production mode.
 * @returns {*|boolean}
 */
function isInProductionMode() {
  return process && process.env && process.env.NODE_ENV === 'production';
}

/**
 * Returns true, if the current app is in PDF rendering mode.
 * @returns {boolean}
 */
function isPdf() {
  return !!window._isPdf;
}